export * from './ProductDetailsIngredientImage';
